// extracted by mini-css-extract-plugin
export default {"modalOptInModalBody":"ModalOptInModal_modalOptInModalBody__L9fX5"};